export default "__VITE_ASSET__DG62OsqC__"